var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0H1.5C0.65625 0 0 0.6875 0 1.5V4C0 4.28125 0.21875 4.5 0.5 4.5H1V13C1 13.5625 1.4375 14 2 14H14C14.5312 14 15 13.5625 15 13V4.5H15.5C15.75 4.5 16 4.28125 16 4V1.5C16 0.6875 15.3125 0 14.5 0ZM13.5 12.5H2.5V4.5H13.5V12.5ZM14.5 3H1.5V1.5H14.5V3ZM6.375 7.5H9.625C9.8125 7.5 10 7.34375 10 7.125V6.375C10 6.1875 9.8125 6 9.625 6H6.375C6.15625 6 6 6.1875 6 6.375V7.125C6 7.34375 6.15625 7.5 6.375 7.5Z",
    fill: "#007040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/Archived.17137fcdd2d3203517fe87aed5c2dc8c.svg";
export { ForwardRef as ReactComponent };